var $ = require('jquery');

export class MailChimpForm {
  private jsBlock;
  private $form;
  private $result;

  constructor(formElement, formClass) {
    this.jsBlock = 'js-' + formClass;
    this.$form = $(formElement);
    this.$result = this.$form.find('.' + this.jsBlock + '__result');
  }

  private showResult(msg) {
    this.$result.html('<p>' + msg + '</p>');
  }

  private submitForm() {
    var self = this;

    $.ajax({
      type: this.$form.attr('method'),
      url: this.$form.attr('action'),
      data: this.$form.serialize(),
      cache: false,
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      error: function(err) {
        self.showResult('Could not connect to server. Please try again later.');
      },
      success: function(data) {
        var message = data.msg;

        if(data.result !== "success") {
          message = data.msg.substring(4);
        }

        self.showResult(message);
      }
    });
  }
  public init() {
    var self = this;

    this.$form.on('submit', function (e) {
      e.preventDefault();
      self.submitForm();
    });
  }
}
